import React from 'react';
import { IFaucetConfig } from '../../common/FaucetConfig';
import { FaucetCaptcha } from '../shared/FaucetCaptcha';

export interface IClaimInputProps {
  faucetConfig: IFaucetConfig
  submitInputs(inputs: any): Promise<void>;
}

export interface IClaimInputState {
  submitting: boolean;
}

export class ClaimInput extends React.PureComponent<IClaimInputProps, IClaimInputState> {
  private faucetCaptcha = React.createRef<FaucetCaptcha>();

  constructor(props: IClaimInputProps) {
    super(props);

    this.state = {
      submitting: false,
		};
  }

	public render(): React.ReactElement<IClaimInputProps> {
    let requestCaptcha = !!this.props.faucetConfig.modules.captcha?.requiredForClaim;

    return (
      <React.Fragment>
        {requestCaptcha ?
          <div className='faucet-captcha'>
            <FaucetCaptcha
              faucetConfig={this.props.faucetConfig}
              ref={this.faucetCaptcha}
              variant='claim'
            />
          </div>
        : null}
        <div className="faucet-actions">
          <button
            className="btn btn-success start-action"
            onClick={(evt) => this.onSubmitBtnClick()}
            disabled={this.state.submitting}>
              Claim Rewards
          </button>
        </div>
      </React.Fragment>
    );
	}

  private async onSubmitBtnClick() {
    this.setState({
      submitting: true
    });

    try {
      let inputData: any = {};

      if(this.props.faucetConfig.modules.captcha?.requiredForClaim) {
        inputData.captchaToken = await this.faucetCaptcha.current?.getToken();
      }

      await this.props.submitInputs(inputData);
    } catch(ex) {
      if(this.faucetCaptcha.current)
        this.faucetCaptcha.current.resetToken();
      throw ex;
    } finally {
      this.setState({
        submitting: false
      });
    }
  }

}
